import { Link } from 'react-router-dom';
import CharmingTowns from './assets/charming town.jpg';
import GardenRouteSA from './assets/garden-route-south-africa.jpg';
import Wildlife from './assets/wildlife.jpg';

function GardenRouteTourPage() {
  return (
    <div className="garden-route-page">
      <section className="hero-subpage garden-route-hero">
        <div className="hero-content">
          <h1>Ebamba's Tailor-Made Garden Route Tour</h1>
          <p>The only way to do the Garden Route is *your* way. You choose your highlights and activities, and our team will craft your perfect itinerary.</p>
          <Link to="/contact" className="btn btn-primary large-btn">Contact Us to Customize Your Tour</Link>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container text-center">
          <h2>Your Bespoke Garden Route Adventure with Ebamba</h2>
          <p>At Ebamba Travel & Tours, we understand that every traveler is unique. That's why we specialize in tailor-made private Garden Route Tours, where you decide exactly what you want to include in your itinerary. Our team of professionals will then create the perfect tour for you, ensuring an unforgettable and personalized experience through this breathtaking region, filled with mesmerizing landscapes, thrilling activities, and cherished memories. Discover the amazing possibilities that await you on your private Garden Route Tour.</p>
        </div>
      </section>

      <section className="section-spacing">
        <div className="container">
          <h2 className="text-center">Why Choose Ebamba for Your Private Garden Route Tour?</h2>
          <div className="why-choose-grid">
            <div className="why-choose-item">
              <h3><i className="fas fa-check-circle"></i> Fully Customizable</h3>
              <p>Itineraries meticulously tailored to your preferences, ensuring a truly personal journey.</p>
            </div>
            <div className="why-choose-item">
              <h3><i className="fas fa-user-tie"></i> Expert Local Guides</h3>
              <p>Immersive experiences led by knowledgeable guides who bring the region to life.</p>
            </div>
            <div className="why-choose-item">
              <h3><i className="fas fa-car"></i> Luxury Transportation</h3>
              <p>Travel in ultimate comfort and convenience with our premium vehicle fleet.</p>
            </div>
            <div className="why-choose-item">
              <h3><i className="fas fa-map-marked-alt"></i> Unparalleled Access</h3>
              <p>Gain access to top attractions and discover hidden gems few ever get to experience.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">The Garden Route: A Tapestry of Natural Wonders & Charming Towns</h2>
          <p className="text-center lead-paragraph">Embark on an unforgettable journey along South Africa’s Garden Route with Ebamba Travel & Tours, a coastal paradise stretching from Mossel Bay to Storms River. This scenic wonderland is a treasure trove of natural beauty, diverse wildlife, thrilling adventures, and charming towns, ready to captivate every traveler.</p>

          <div className="content-with-image left">
            <img src={GardenRouteSA} alt="Coastal Kaleidoscope" />
            <div>
              <h3>A Coastal Kaleidoscope</h3>
              <p>The Garden Route unfolds like a painter’s palette, showcasing a breathtaking tapestry of landscapes. Lush forests, golden beaches, towering cliffs, and tranquil lagoons create a mesmerizing panorama that changes with every turn, inviting you to discover its endless beauty.</p>
            </div>
          </div>

          <div className="content-with-image right">
            <div>
              <h3>Rich Wildlife Encounters</h3>
              <p>The Garden Route is home to a rich variety of wildlife, both on land and in the ocean. Birdwatchers will delight in spotting colorful Knysna loeries and majestic African fish eagles. Marine enthusiasts can take a boat trip to Seal Island or embark on a thrilling whale-watching excursion. For those seeking the "Big 5," venture inland to one of the region's private game reserves for an unforgettable safari adventure.</p>
            </div>
            <img src={Wildlife} alt="Wildlife Encounters" />
          </div>

          <div className="content-with-image left">
            <img src={CharmingTowns} alt="Charming Towns" />
            <div>
              <h3>Charming Towns & Villages</h3>
              <p>The Garden Route is dotted with charming towns and villages, each with its own unique character. Explore Knysna’s picturesque lagoon, enjoy the pristine beaches of Plettenberg Bay, or venture to Oudtshoorn, the "ostrich capital," to discover its farms and the Cango Caves.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-spacing">
        <div className="container text-center">
          <h2>Thrilling Adventures Await</h2>
          <p className="lead-paragraph">For adrenaline junkies, the Garden Route offers an array of heart-pounding activities that Ebamba can arrange for you:</p>
          <div className="adventure-grid">
            <div className="adventure-item">
              <i className="fas fa-parachute-box"></i>
              <h3>Bungee Jumping</h3>
              <p>Take the plunge from the world’s highest bungee bridge at Bloukrans Bridge.</p>
            </div>
            <div className="adventure-item">
              <i className="fas fa-tree"></i>
              <h3>Treetop Canopy Tours</h3>
              <p>Soar through the forest canopy on an exhilarating zipline adventure.</p>
            </div>
            <div className="adventure-item">
              <i className="fas fa-hiking"></i>
              <h3>Hiking & Biking</h3>
              <p>Explore numerous trails winding through forests, along rivers, and up mountains.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container text-center">
          <h2>Culinary Delights & Local Flavors</h2>
          <p className="lead-paragraph">The Garden Route’s culinary scene is as diverse as its landscapes. Ebamba can guide you to the best experiences:</p>
          <div className="culinary-grid">
            <div className="culinary-item">
              <i className="fas fa-fish"></i>
              <h3>Fresh Seafood</h3>
              <p>Savor fresh catches at seaside restaurants and gourmet establishments.</p>
            </div>
            <div className="culinary-item">
              <i className="fas fa-wine-glass-alt"></i>
              <h3>Wine & Craft Beer Tasting</h3>
              <p>Visit local wine estates and breweries to sample award-winning beverages.</p>
            </div>
            <div className="culinary-item">
              <i className="fas fa-leaf"></i>
              <h3>Farm-to-Table Dining</h3>
              <p>Enjoy dishes crafted with fresh, locally sourced ingredients from the region.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-spacing primary-bg-dark text-white text-center">
        <div className="container">
          <h2>Start Your Ebamba Garden Route Journey of Discovery</h2>
          <p>The Garden Route Tour is more than just a destination; it’s a journey of discovery. With its diverse landscapes, abundant wildlife, thrilling adventures, and warm hospitality, this coastal paradise promises an unforgettable experience. Let Ebamba Travel & Tours craft your unique itinerary for lasting memories.</p>
          <Link to="/contact" className="btn btn-secondary large-btn tour-btn">Plan Your Garden Route Tour Now</Link>
        </div>
      </section>
    </div>
  );
}

export default GardenRouteTourPage;
